import { useContext, useEffect, useState } from 'react'
import EmptyAdress from '../EmptyAdress'
import IconEdit from '../../../assets/icons/icon-edit.svg'
import IconRemove from '../../../assets/icons/icon-remove.svg'
import * as S from './styles'
import { useToast } from '../../../hooks/toast'
import { isPF } from '../../../api/auth/auth'
import { UserContext } from '../../../contexts/UserContext'
import { useMutation, useQueryClient } from 'react-query'
import { editAddressById, getAddressList } from '../../../hooks/address/useAddresses'

const AddressCard = ({ address, setCurrent, deleteModal, setCardId }) => {
  const { addToast } = useToast()
  const { user, setLoading } = useContext(UserContext)
  const [checked, setChecked] = useState('')
  const queryClient = useQueryClient()

  const { mutateAsync, error } = useMutation(editAddressById, {
    onSuccess: () => {
      addToast({
        type: 'success',
        title: `Endereço definido como Padrão`
      })

      queryClient.invalidateQueries('enderecos')
    },
    onError: () => {
      addToast({
        type: 'error',
        title: 'Erro ao definir endereço padrão',
        description: `${error}`
      })
    }
  })

  const capitalize = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
      .join(' ')
  }

  const isMaxAdressLimit = () => {
    if (address?.length >= 5) {
      addToast({
        type: 'error',
        title:
          'Máximo de 4 endereços de entrega. Remova algum endereço para adicionar um novo'
      })
      return true
    }
  }

  const handleSubmit = async (id) => {
    const item = await address?.find((element) => element.id === id)
    setLoading(true)

    const formData = {
      ...item,
      padrao: true
    }

    try {
      mutateAsync(formData)
    } catch (err) {
      if (err) {
        const emptyField = Object.values(err.value).every(
          (value) => value !== ''
        )

        if (!emptyField) {
          addToast({
            type: 'error',
            title: 'Todos os campos devem ser preenchidos'
          })
        } else {
          err.inner.map((error) => {
            return addToast({
              type: 'error',
              title: `Erro ao adicionar endereço`,
              description: `${error.message}`
            })
          })
        }
      }
    }
  }

  const checkPadrao = async () => {
    const isTherePadrao = await address?.every(
      (address) => address?.padrao === false
    )

    const faturamento = await address?.find(
      (element) => element.apelido === 'Faturamento'
    )
    if (!!isTherePadrao && faturamento !== undefined) {
      // console.log(address)
      // console.log('AdsFat:', faturamento)
      handleSubmit(faturamento.id)
    }
  }

  useEffect(() => {
    !!isPF() && checkPadrao()
  }, [address])

  const ufsPermitidas = ['SP', 'RJ']

  const allowNewAddress = async (address) => {
    if (!address)
    address = await getAddressList();
    const faturamento = address?.filter((item) => item.tipoEndereco === 'C')

    if (
      !isPF() &&
      !ufsPermitidas.includes(faturamento[0]?.uf) &&
      user.inscricaoEstadual !== 'ISENTO'
    ) {
      return false
    } else if (!isPF() && user.inscricaoEstadual === 'ISENTO') {
      return true
    } else {
      return true
    }
    // return faturamento[0].uf
  }

  return (
    <>
      {/* {loading ? <Loader></Loader> : null} */}
      <S.PageContent>
        <S.ProfileTitle className="perfil-title">Meus Endereços</S.ProfileTitle>

        <S.Wrapper className="">
          {address?.length > 0 ? (
            <>
              {allowNewAddress(address)
                ? address?.map(
                    (
                      {
                        padrao,
                        apelido,
                        tipoEndereco,
                        id,
                        tipoLogradouro,
                        logradouro,
                        numero,
                        bairro,
                        cidade,
                        uf,
                        cep
                      },
                      i
                    ) => {
                      return (
                        <>
                          <S.CardWrapper className="" key={i}>
                            <S.CardBox className="perfil-box">
                              <S.CardConfig className="endereco-card-config">
                                <S.CardLink
                                  className="endereco-card-link"
                                  onClick={() => {
                                    setCardId(id)
                                    setCurrent(2)
                                  }}
                                >
                                  <img src={IconEdit} alt="" />
                                </S.CardLink>
                                {tipoEndereco === 'E' && (
                                  <S.CardLink
                                    className="endereco-card-link"
                                    onClick={() => deleteModal(id)}
                                  >
                                    <img src={IconRemove} alt="" />
                                  </S.CardLink>
                                )}
                              </S.CardConfig>

                              <S.CardAddressType
                                className="endereco-card-title apelido"
                                title={capitalize(apelido)}
                              >
                                <p>{capitalize(apelido)}</p>
                              </S.CardAddressType>
                              {tipoLogradouro ===
                              logradouro.trim().split(' ')[0] ? (
                                <S.Address
                                  className="endereco-card-title logradouro"
                                  title={`${capitalize(
                                    tipoLogradouro
                                  )} ${capitalize(logradouro)} ${numero}`}
                                  // cropText={logradouro.length + numero.length > 40}
                                >
                                  <p>
                                    {capitalize(logradouro)}{' '}
                                    <span>{numero}</span>
                                  </p>
                                </S.Address>
                              ) : (
                                <S.Address className="endereco-card-title">
                                  <p>
                                    {capitalize(tipoLogradouro)}{' '}
                                    {capitalize(logradouro)}{' '}
                                    <span>{numero}</span>
                                  </p>
                                </S.Address>
                              )}

                              <S.AddressDescription
                                className="endereco-card-description"
                                title={`${bairro} - ${cidade} / ${uf} - ${cep}`}
                                // cropText={
                                //   `${bairro} - ${cidade} / ${uf} - ${cep}`.length > 40
                                // }
                              >
                                <p>
                                  {capitalize(bairro)} - {capitalize(cidade)} /{' '}
                                  {uf} - {cep}
                                </p>
                              </S.AddressDescription>

                              {/* <button
                            onClick={() => {
                              if (checkPadrao()) {
                                console.log('Definir Faturamento como padrão')
                              }
                              // console.log(padrao)
                            }}
                          >
                            Padrão?
                          </button> */}
                              {!!isPF() && (
                                <>
                                  <input
                                    type="radio"
                                    id={`endereco-padrao${i}`}
                                    value={padrao}
                                    name={id}
                                    readOnly
                                    checked={checked == id || padrao === true}
                                    onClick={async (e) => {
                                      await setCardId(id)
                                      if (e.target.name == id) {
                                        setChecked(e.target.name)
                                      }
                                      handleSubmit(id)
                                    }}
                                  />

                                  <label
                                    htmlFor={`endereco-padrao${i}`}
                                    style={{ marginTop: 8 }}
                                  >
                                    Definir como endereço padrão
                                  </label>
                                </>
                              )}
                            </S.CardBox>
                          </S.CardWrapper>
                        </>
                      )
                    }
                  )
                : address
                    .filter((item) => item.tipoEndereco === 'C')
                    .map(
                      (
                        {
                          padrao,
                          apelido,
                          tipoEndereco,
                          id,
                          tipoLogradouro,
                          logradouro,
                          numero,
                          bairro,
                          cidade,
                          uf,
                          cep
                        },
                        i
                      ) => {
                        return (
                          <>
                            <S.CardWrapper className="" key={i}>
                              <S.CardBox className="perfil-box">
                                <S.CardConfig className="endereco-card-config">
                                  <S.CardLink
                                    className="endereco-card-link"
                                    onClick={() => {
                                      setCardId(id)
                                      setCurrent(2)
                                    }}
                                  >
                                    <img src={IconEdit} alt="" />
                                  </S.CardLink>
                                  {tipoEndereco === 'E' && (
                                    <S.CardLink
                                      className="endereco-card-link"
                                      onClick={() => deleteModal(id)}
                                    >
                                      <img src={IconRemove} alt="" />
                                    </S.CardLink>
                                  )}
                                </S.CardConfig>

                                <S.CardAddressType className="endereco-card-title">
                                  {capitalize(apelido)}
                                </S.CardAddressType>
                                {tipoLogradouro ===
                                logradouro.trim().split(' ')[0] ? (
                                  <S.Address
                                    className="endereco-card-title logradouro"
                                    title={`${capitalize(
                                      tipoLogradouro
                                    )} ${capitalize(logradouro)} ${numero}`}
                                    // cropText={logradouro.length + numero.length > 40}
                                  >
                                    <p>
                                      {capitalize(logradouro)}{' '}
                                      <span>{numero}</span>
                                    </p>
                                  </S.Address>
                                ) : (
                                  <S.Address className="endereco-card-title">
                                    <p>
                                      {capitalize(tipoLogradouro)}{' '}
                                      {capitalize(logradouro)}{' '}
                                      <span>{numero}</span>
                                    </p>
                                  </S.Address>
                                )}

                                <S.AddressDescription
                                  className="endereco-card-description"
                                  title={`${bairro} - ${cidade} / ${uf} - ${cep}`}
                                  // cropText={
                                  //   `${bairro} - ${cidade} / ${uf} - ${cep}`.length > 40
                                  // }
                                >
                                  <p>
                                    {capitalize(bairro)} - {capitalize(cidade)}{' '}
                                    / {uf} - {cep}
                                  </p>
                                </S.AddressDescription>

                                {/* <button
                          onClick={() => {
                            if (checkPadrao()) {
                              console.log('Definir Faturamento como padrão')
                            }
                            // console.log(padrao)
                          }}
                        >
                          Padrão?
                        </button> */}
                                {!!isPF() && (
                                  <>
                                    <input
                                      type="radio"
                                      id={`endereco-padrao${i}`}
                                      value={padrao}
                                      name={id}
                                      readOnly
                                      checked={checked == id || padrao === true}
                                      onClick={async (e) => {
                                        await setCardId(id)
                                        if (e.target.name == id) {
                                          setChecked(e.target.name)
                                        }
                                        handleSubmit(id)
                                      }}
                                    />

                                    <label
                                      htmlFor={`endereco-padrao${i}`}
                                      style={{ marginTop: 8 }}
                                    >
                                      Definir como endereço padrão
                                    </label>
                                  </>
                                )}
                              </S.CardBox>
                            </S.CardWrapper>
                          </>
                        )
                      }
                    )}
            </>
          ) : (
            <EmptyAdress />
          )}
        </S.Wrapper>

        {/* {console.log(store.user.info.inscricaoEstadual !== 'ISENTO' && )} */}
        {/* {console.log(address?.filter((item) => item.tipoEndereco === 'C'))} */}

        {allowNewAddress(address) && (
          <S.ProfileBoxFooter>
            <S.ButtonAddNewAddress
              className="button button-primary"
              onClick={() => {
                // if (!isPF()) {
                //   allowAddAdressPJ()
                // } else if (!isMaxAdressLimit()) {
                //   setCurrent(0)
                // }
                if (!isMaxAdressLimit()) {
                  setCurrent(0)
                }
              }}
            >
              Adicionar Endereço
            </S.ButtonAddNewAddress>
          </S.ProfileBoxFooter>
        )}
      </S.PageContent>
    </>
  )
}

export default AddressCard
